import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-card-item" }

import { computed } from 'vue';
import ProductCardLens from './ProductCardLens.vue';
import ProductCardLensCare from './ProductCardLensCare.vue';
import ProductCardMultiPower from './ProductCardMultiPower.vue';
import type { LensProperty, ProductImage, Variant } from '@/models/webshop.model';
import { PRODUCT_CATEGORY_LENS_CARE } from '@/constants/webshop';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    mlsId: {},
    productCategory: {},
    productCategorySlug: {},
    title: {},
    image: {},
    lensProperties: {},
    variants: {},
    lensCode: {},
    powerSelectionMode: {},
    dataDusk: {}
  },
  setup(__props: any) {

const props = __props;

const isMultiPowerMode = computed(() => props.powerSelectionMode === 'multi');
const isLensCare = computed(() => props.productCategory === PRODUCT_CATEGORY_LENS_CARE);
const cardDusk = computed(() => props.dataDusk || 'product-card-id');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isMultiPowerMode.value)
      ? (_openBlock(), _createBlock(ProductCardMultiPower, {
          key: 0,
          "mls-id": _ctx.mlsId,
          "product-category": _ctx.productCategory,
          "product-category-slug": _ctx.productCategorySlug,
          title: _ctx.title,
          image: _ctx.image,
          "lens-properties": _ctx.lensProperties,
          variants: _ctx.variants,
          "lens-code": _ctx.lensCode,
          "data-dusk": cardDusk.value
        }, null, 8, ["mls-id", "product-category", "product-category-slug", "title", "image", "lens-properties", "variants", "lens-code", "data-dusk"]))
      : (isLensCare.value)
        ? (_openBlock(), _createBlock(ProductCardLensCare, {
            key: 1,
            "mls-id": _ctx.mlsId,
            "product-category": _ctx.productCategory,
            "product-category-slug": _ctx.productCategorySlug,
            title: _ctx.title,
            image: _ctx.image,
            "lens-properties": _ctx.lensProperties,
            variants: _ctx.variants,
            "data-dusk": cardDusk.value
          }, null, 8, ["mls-id", "product-category", "product-category-slug", "title", "image", "lens-properties", "variants", "data-dusk"]))
        : (_openBlock(), _createBlock(ProductCardLens, {
            key: 2,
            "mls-id": _ctx.mlsId,
            "product-category": _ctx.productCategory,
            "product-category-slug": _ctx.productCategorySlug,
            title: _ctx.title,
            image: _ctx.image,
            "lens-properties": _ctx.lensProperties,
            variants: _ctx.variants,
            "lens-code": _ctx.lensCode,
            "data-dusk": cardDusk.value
          }, null, 8, ["mls-id", "product-category", "product-category-slug", "title", "image", "lens-properties", "variants", "lens-code", "data-dusk"]))
  ]))
}
}

})